var scope_0 = require('/home/runner/work/gatsby-site/gatsby-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/048b2821a0bb11c5cf3dcd05865e3787.js').default;
var scope_1 = require('/home/runner/work/gatsby-site/gatsby-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_2 = require('/home/runner/work/gatsby-site/gatsby-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f0767681d232ef9bcf539d862e3c82fc.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    